import { Chip } from "@mui/material";
import useSWR from "swr";

import { FetchOptions, SWRType } from "../types/global";
import { Task } from "../types/task";
import { authFetcher } from "../utils/auth-fetch";

const useTask = (
  autoFetch = false,
  options: FetchOptions | null = null,
  props: Record<string, any> = {},
) => {
  let swrUrl = "tasks";
  if (options?.fetchOne) {
    swrUrl = `tasks/${options.id}`;
  }

  const {
    data,
    isLoading: dataLoading,
    mutate,
    error,
  }: SWRType = useSWR(
    autoFetch ? [swrUrl, props] : null,
    ([url, queryParams]) => authFetcher("GET", url, null, queryParams),
    {
      // revalidateOnFocus: false,
      // revalidateOnReconnect: false,
      onErrorRetry: (error) => {
        if (error.status === 404) return;
      },
    },
  );

  const getStageStatus = (status: string) => {
    switch (status) {
      case "created":
        return <Chip label="Task Created" size="small" />;
      case "calling":
        return <Chip label="Calling" color="info" size="small" />;
      case "order_created":
        return <Chip label="Order Created" color="warning" size="small" />;
      case "support_pending":
        return <Chip label="Support Pending" color="lavender" size="small" />;
      case "pending_inprogress":
        return (
          <Chip label="Pending In Progress" color="secondary" size="small" />
        );
      case "support_closed":
        return <Chip label="Support Closed" color="error" size="small" />;
      case "support_cancelled":
        return <Chip label="Support Cancelled" size="small" />;
      case "waiting_qc":
        return <Chip label="Waiting QC" color="lavender" size="small" />;
      case "qc_calling":
        return <Chip label="QC Calling" color="info" size="small" />;
      case "qc_pass":
        return <Chip label="QC Pass" color="success" size="small" />;
      case "reject":
        return <Chip label="Reject" color="error" size="small" />;
      default:
        return <Chip label="Unknown" size="small" />;
    }
  };

  const getRejectedCount = (data: Task, showLabel: boolean = false) => {
    if (data?.histories && data.histories.length > 0) {
      const rejectedCount = data.histories.filter(
        (history) => history.action === "qc_reject",
      ).length;
      if (rejectedCount > 0) {
        if (showLabel) {
          return rejectedCount;
        }
        return <Chip label={rejectedCount} color="red" size="small" />;
      }
    }
    return "-";
  };

  const getTaskNo = (data: Task) => {
    return (
      <div className="flex flex-col gap-1">
        {data?.is_urgent_task ? (
          <Chip label={data?.number} size="medium" color="red" />
        ) : (
          <>{data?.number}</>
        )}
      </div>
    );
  };

  return {
    data,
    dataLoading,
    mutate,
    error,
    getStageStatus,
    getRejectedCount,
    getTaskNo,
  };
};

export default useTask;
